module.exports = __webpack_public_path__ + "37ba7b92/img/comments-icon.fdec7fdb.svg";